import { render, staticRenderFns } from "./fullInfo.vue?vue&type=template&id=c60fc00e&scoped=true"
import script from "./fullInfo.vue?vue&type=script&lang=js"
export * from "./fullInfo.vue?vue&type=script&lang=js"
import style0 from "./fullInfo.vue?vue&type=style&index=0&id=c60fc00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60fc00e",
  null
  
)

export default component.exports